import type { JumpChart } from '../jumpChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_PRISM } from '../builtinPulseMaps/palettes.js';
import { assembleJumpChartFromCircles } from './jumpFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/diamond.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/diamond-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/diamond-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/diamond-extreme.circles.json' with { type: 'json' };

export const DIAMOND_JUMP_VARIANTS: Record<Variant, JumpChart> = assembleJumpChartFromCircles({
  baseSlug: 'diamond',
  baseTitle: "The Return",
  description: "NIVIRO's 128 BPM future bass. Cube run on the million-play ranked osu! set's diff spread.",
  difficulty: 3,
  palette: PALETTE_PRISM,
  attribution: "\"The Return\" by NIVIRO [NCS Release] - https://ncs.io/TheReturn",
  mapper: "Nuvolina & kiry",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 64, offsetMs: 0, totalBeats: 67 },
    hard: { bpm: 64, offsetMs: 0, totalBeats: 67 },
    extreme: { bpm: 64, offsetMs: 0, totalBeats: 67 },
  },
});
